module.exports = __webpack_public_path__ + "img/nz.a57708c5.svg";